import { PAYMENTS_BALANCE_ANCHOR, PAYMENTS_PATH } from '~/helpers/recharge';

export default () => {
  const route = useRoute();
  const localePath = useLocalePath();
  const requests = useState<number>('payments-balance-focus', () => 0);
  const paymentsPath = computed<string>(() => localePath(PAYMENTS_PATH));
  const rechargeLink = computed<string>(
    () => `${paymentsPath.value}#${PAYMENTS_BALANCE_ANCHOR}`,
  );

  // A link to the hash that is already open does not change the hash, so the click asks the page to focus again.
  const onRechargeLinkClick = (): void => {
    if (
      route.path === paymentsPath.value &&
      route.hash === `#${PAYMENTS_BALANCE_ANCHOR}`
    ) {
      requests.value += 1;
    }
  };

  return { rechargeLink, requests, onRechargeLinkClick };
};
